/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Tier_Free_Feature_4Inputs */

const en_pricing_tier_free_feature_4 = /** @type {(inputs: Pricing_Tier_Free_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 3 papers a week`)
};

const es_pricing_tier_free_feature_4 = /** @type {(inputs: Pricing_Tier_Free_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 3 artículos por semana`)
};

/**
* | output |
* | --- |
* | "Up to 3 papers a week" |
*
* @param {Pricing_Tier_Free_Feature_4Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_tier_free_feature_4 = /** @type {((inputs?: Pricing_Tier_Free_Feature_4Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Tier_Free_Feature_4Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_tier_free_feature_4(inputs)
	return en_pricing_tier_free_feature_4(inputs)
});